import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { FormikConsumer } from 'formik';
export var Debug = function Debug() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "3rem 0",
      borderRadius: 4,
      background: "#f6f8fa",
      boxShadow: "0 0 1px  #eee inset"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textTransform: "uppercase",
      fontSize: 11,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      fontWeight: 500,
      padding: ".5rem",
      background: "#555",
      color: "#fff",
      letterSpacing: "1px"
    }
  }, "Formik State"), /*#__PURE__*/React.createElement(FormikConsumer, null, function (_ref) {
    var validationSchema = _ref.validationSchema,
        validate = _ref.validate,
        onSubmit = _ref.onSubmit,
        rest = _objectWithoutProperties(_ref, ["validationSchema", "validate", "onSubmit"]);

    return /*#__PURE__*/React.createElement("pre", {
      style: {
        fontSize: ".65rem",
        padding: ".25rem .5rem",
        overflowX: "scroll"
      }
    }, JSON.stringify(rest, null, 2));
  }));
};